var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var GeminiIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '20' : _b, _c = _a.height, height = _c === void 0 ? '20' : _c;
    return (_jsxs("svg", __assign({ width: width, height: height, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", className: "inline-block" }, { children: [_jsx("circle", { cx: "10", cy: "10", r: "10", fill: "currentColor" }), _jsx("path", { d: "M10 3L12.5 7L17 8.5L12.5 10L10 14L7.5 10L3 8.5L7.5 7L10 3Z", fill: "white" })] })));
};
export default GeminiIcon;
